import React, { useCallback, useState } from "react";
import { WANoteComponent } from "../../Storecast/Storecast/Widgets/WidgetNote/WANoteComponent";
import { UserLoggedInNavigatorScreenProps } from "../../../TopLevelNavigators/UserLoggedIn/UserLoggedInNavigatorParamList";
import { withWebModal } from "@/src/TopLevelNavigators/UserLoggedIn/withWebModal";
import { graphql, useMutation } from "react-relay";
import { useWANotePreviewQueryLoader } from "../../Storecast/Storecast/Widgets/WidgetNote/useWANotePreviewQueryLoader";
import { WANotePreview } from "../../Storecast/Storecast/Widgets/WidgetNote/WANotePreview";
import { OrgSpaceWidgetAddNoteMutation } from "./__generated__/OrgSpaceWidgetAddNoteMutation.graphql";
import { WidgetSizeT } from "../../Storecast/Storecast/localTypes/WidgetSizeT";
import { WAWidgetSizeToNoteSize } from "../../Storecast/Storecast/WidgetAdd/utils/WAWidgetSizeToNoteSize";
import { useOrgSpaceUnitSize } from "../OrgSpaces/useOrgSpaceUnitSize";

function InnerOrgSpaceWidgetAddNote(
  props: UserLoggedInNavigatorScreenProps<"OrgSpaceWidgetAddNote">
) {
  const [title, setTitle] = useState("");

  const [create, loading] = useMutation<OrgSpaceWidgetAddNoteMutation>(graphql`
    mutation OrgSpaceWidgetAddNoteMutation(
      $spaceId: ID!
      $widget: CreateWidgetNoteInput!
    ) {
      storecastSpace(id: $spaceId) {
        createWidgetNote(widget: $widget) {
          ...WidgetNote_widgetNote
        }
      }
    }
  `);

  const onCreate = useCallback(
    (
      size: WidgetSizeT,
      pages: {
        currentValue: string;
        fontSize: any;
        fontStyle: any;
        includedInSlideshow: boolean;
        backgroundColor: string | null;
        remoteImageURL: string | undefined;
      }[]
    ) => {
      create({
        variables: {
          spaceId: props.route.params.spaceId,
          widget: {
            positionX: props.route.params.position.x,
            positionY: props.route.params.position.y,
            size: WAWidgetSizeToNoteSize(size),
            title,
            pages,
          },
        },
        onCompleted: () => {
          props.navigation.pop(2);
        },
        onError: (error) => {
          console.error(error);
        },
      });
    },
    [
      create,
      props.navigation,
      props.route.params.position.x,
      props.route.params.position.y,
      props.route.params.spaceId,
      title,
    ]
  );

  const queryRef = useWANotePreviewQueryLoader(
    props.route.params.template ?? "empty",
    "",
    "ORGSPACE_WA_CATEGORY_NOTE_PREVIEWS_QUERY:"
  );

  const unitSize = useOrgSpaceUnitSize();

  return (
    <WANoteComponent
      dataPrefix="orgSpaceWidgetAdd"
      loading={loading}
      maxSize={props.route.params.maxSize}
      onCreate={onCreate}
      preview={
        queryRef ? (
          <WANotePreview queryRef={queryRef} clientTitle={title} />
        ) : null
      }
      setTitle={setTitle}
      title={title}
      template={props.route.params.template}
      unitSize={unitSize}
    />
  );
}

export const OrgSpaceWidgetAddNote = withWebModal(InnerOrgSpaceWidgetAddNote);
